module.exports = __webpack_public_path__ + "ee8fdd99be01f077ec536a93c2f275e8.png";


//////////////////
// WEBPACK FOOTER
// ../img/Block_3.png
// module id = 483
// module chunks = 0